var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1509 43.9998C33.7829 43.9998 33.4309 43.8478 33.1789 43.5798L26.6949 36.6745C26.1895 36.1385 26.2175 35.2945 26.7535 34.7905C27.2909 34.2865 28.1349 34.3132 28.6375 34.8492L34.1375 40.7038L45.3482 28.4345C45.8469 27.8892 46.6895 27.8532 47.2335 28.3492C47.7762 28.8452 47.8135 29.6892 47.3175 30.2318L35.1349 43.5652C34.8855 43.8398 34.5309 43.9972 34.1602 43.9998H34.1509Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptCircle);
export default __webpack_public_path__ + "static/media/accept-circle.741df50ba2d971cc84de2294d915188d.svg";
export { ForwardRef as ReactComponent };